import { createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea6df240"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "h-100",
  style: {"background-color":"#ffffff"}
}
const _hoisted_2 = { class: "manual-right-div" }
const _hoisted_3 = { style: {"margin-left":"2%"} }
const _hoisted_4 = {
  id: "manualdiv",
  class: "manual-main-div"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"calc(100% - 16px)"} }, [
  /*#__PURE__*/_createElementVNode("table", { id: "tbltitlemanual" }, [
    /*#__PURE__*/_createElementVNode("thead", null, [
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("th", { width: "100%" }, "Manual List")
      ])
    ])
  ])
], -1 /* HOISTED */))
const _hoisted_6 = {
  key: 0,
  style: {"text-align":"center","width":"calc(100% - 16px)"}
}
const _hoisted_7 = {
  key: 1,
  id: "tblbodydiv",
  style: {"overflow":"auto","height":"calc(100% - 60px)"}
}
const _hoisted_8 = { id: "tblmanualInfo" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  width: "100%",
  class: "categorylist"
}
const _hoisted_11 = { class: "manuallist" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" ■")
const _hoisted_13 = { class: "cssFileSize" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "cssFileSize" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createVNode($setup["Navigation"]),
    _createVNode($setup["InquiryNavigation"], { menuTile: $setup.title }, null, 8 /* PROPS */, ["menuTile"]),
    _createVNode($setup["InquiryLinkNavigation"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode($setup["Alert"], {
          alertMessage: $setup.alertMessage,
          alertState: $setup.alertState
        }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
      ]),
      _createCommentVNode(" Manual Table Start "),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        ($setup.manualInfo.length === 0 && $setup.getData)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_6, " No data "))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.manualInfo[0], (item, index) => {
                  return (_openBlock(), _createElementBlock("tbody", {
                    id: "tbltbody",
                    key: index
                  }, [
                    (index == 0 || item.category != $setup.manualInfo[0][index - 1].category)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                          _createElementVNode("td", _hoisted_10, _toDisplayString(item.category), 1 /* TEXT */)
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_11, [
                        _hoisted_12,
                        (item.name == 'SUZUKI Spare Parts Manual')
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "manual-link",
                              style: {"cursor":"pointer"},
                              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openWindow('DST01470')))
                            }, [
                              _createTextVNode(_toDisplayString(item.name) + "  ", 1 /* TEXT */),
                              _createElementVNode("span", _hoisted_13, _toDisplayString(item.fileSize), 1 /* TEXT */)
                            ]))
                          : (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              class: "manual-link",
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => ($setup.openManualFile(item.fileName, item.fileSize))
                            }, [
                              _createTextVNode(_toDisplayString(item.name) + "  ", 1 /* TEXT */),
                              _createElementVNode("span", _hoisted_15, _toDisplayString(item.fileSize), 1 /* TEXT */)
                            ], 8 /* PROPS */, _hoisted_14))
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])),
        _createCommentVNode(" Manual Table End ")
      ])
    ])
  ]))
}